import {
  DWELLER_USER_ROLE,
  LANDLORD_USER_ROLE,
} from '../../../../constants/user'

export const REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION = {
  dwellers: 'dwellers',
  landlords: 'landlords',
}

export const REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_TITLE_KEY = {
  [REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION.dwellers]:
    'RequestProfile.DwellersAndLandlordsWidgetDwellersTitleKey',
  [REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION.landlords]:
    'RequestProfile.DwellersAndLandlordsWidgetLandlordsTitleKey',
}

export const REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_VIEW_SETTING_NAME =
  {
    [REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION.dwellers]: {
      [DWELLER_USER_ROLE]: 'can_dweller_view_dweller_request',
      [LANDLORD_USER_ROLE]: 'can_dweller_view_landlord_request',
    },
    [REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION.landlords]: {
      [DWELLER_USER_ROLE]: 'can_landlord_view_dweller_request',
      [LANDLORD_USER_ROLE]: 'can_landlord_view_landlord_request',
    },
  }

export const REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION_VISIBILITY_TOOLTIP_KEY =
  {
    [REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION.dwellers]: {
      hidden:
        'RequestProfile.DwellersAndLandlordsWidgetDwellersHiddenTooltipKey',
      visible:
        'RequestProfile.DwellersAndLandlordsWidgetDwellersVisibleTooltipKey',
    },
    [REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_SECTION.landlords]: {
      hidden:
        'RequestProfile.DwellersAndLandlordsWidgetLandlordsHiddenTooltipKey',
      visible:
        'RequestProfile.DwellersAndLandlordsWidgetLandlordsVisibleTooltipKey',
    },
  }
